'use strict';
(function () {
  if (window.__VSKLO_RUNTIME_CORE_V1__) return;
  window.__VSKLO_RUNTIME_CORE_V1__ = true;

  var MOBILE_MAX = 1024;
  var DESKTOP_MIN = 1025;
  var NAV_COMPACT_MAX = 1366;
  window.VSKLOBreakpoints = Object.freeze({
    mobileMax: MOBILE_MAX,
    desktopMin: DESKTOP_MIN,
    navigationCompactMax: NAV_COMPACT_MAX,
    mobileQuery: '(max-width: ' + MOBILE_MAX + 'px)',
    desktopQuery: '(min-width: ' + DESKTOP_MIN + 'px)',
    drawerQuery: '(max-width: ' + NAV_COMPACT_MAX + 'px)'
  });
  window.VSKLOIsMobile = function () {
    return window.matchMedia ? window.matchMedia(window.VSKLOBreakpoints.mobileQuery).matches : window.innerWidth <= MOBILE_MAX;
  };

  window.VSKLOIsCartMobile = window.VSKLOIsCartMobile || function () {
    if (window.VSKLOIsMobile()) return true;

    var nav = window.navigator || {};
    var uaData = nav.userAgentData;
    if (uaData && typeof uaData.mobile === 'boolean' && uaData.mobile) return true;

    var ua = String(nav.userAgent || '');
    if (/Android|iPhone|iPod|iPad|IEMobile|Opera Mini|Mobile/i.test(ua)) return true;
    if (nav.platform === 'MacIntel' && Number(nav.maxTouchPoints || 0) > 1) return true;

    return Boolean(
      Number(nav.maxTouchPoints || 0) > 0 &&
      window.matchMedia &&
      window.matchMedia('(hover: none) and (pointer: coarse)').matches
    );
  };

  function syncCartDeviceClass() {
    var mobile = window.VSKLOIsCartMobile();
    document.documentElement.classList.toggle('vsklo-cart-mobile', mobile);
    document.documentElement.classList.toggle('vsklo-cart-desktop', !mobile);
    return mobile;
  }
  window.VSKLOSyncCartDeviceClass = syncCartDeviceClass;
  syncCartDeviceClass();

  if (window.matchMedia) {
    var cartModeMedia = window.matchMedia(window.VSKLOBreakpoints.mobileQuery);
    var handleCartModeChange = function () {
      var mobile = syncCartDeviceClass();
      if (mobile && typeof window.vskloForceCloseMobileMinicartShell === 'function') {
        window.vskloForceCloseMobileMinicartShell();
      }
    };
    if (cartModeMedia.addEventListener) cartModeMedia.addEventListener('change', handleCartModeChange);
    else if (cartModeMedia.addListener) cartModeMedia.addListener(handleCartModeChange);
  }

  var registry = new Map();
  var scheduled = false;
  var pendingScope = document;

  function validScope(scope) {
    return scope && typeof scope.querySelectorAll === 'function' ? scope : document;
  }

  function run(scope) {
    var root = validScope(scope);
    var builtins = [
      ['theme-components', window.VSKLOHydrateThemeComponents],
      ['addon-v3', window.VSKLOAddonV3 && window.VSKLOAddonV3.init],
      ['pdp-addon', window.VSKLOInitPDPAddon],
      ['pdp-gallery-video', window.VSKLOMountPDPGalleryVideos],
      ['pdp-gallery', window.VSKLOInitPDPGallery],
      ['mobile-drawer', window.VSKLOInitMobileDrawer],
      ['overlay-sync', window.vskloSyncOverlayState]
    ];
    builtins.forEach(function (entry) {
      if (typeof entry[1] !== 'function') return;
      try { entry[1](root); }
      catch (error) { console.error('[VSKLO hydration:' + entry[0] + ']', error); }
    });
    registry.forEach(function (init, name) {
      try { init(root); }
      catch (error) { console.error('[VSKLO hydration:' + name + ']', error); }
    });
  }

  function schedule(scope) {
    var nextScope = validScope(scope);
    if (scheduled) {
      if (pendingScope !== nextScope) pendingScope = document;
      return;
    }
    pendingScope = nextScope;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      var root = pendingScope;
      pendingScope = document;
      run(root);
    });
  }

  window.VSKLOHydration = {
    register: function (name, init) {
      if (!name || typeof init !== 'function') return;
      registry.set(String(name), init);
    },
    unregister: function (name) { registry.delete(String(name)); },
    run: run,
    schedule: schedule
  };

  var overlayOwners = new Set();
  var popupClassOwnedByOverlayState = false;
  function syncOverlayClass() {
    var open = overlayOwners.size > 0;
    var html = document.documentElement;
    html.classList.toggle('vsklo-ui-overlay-open', open);
    if (document.body) document.body.classList.toggle('vsklo-ui-overlay-open', open);

    var popupOpen =
      overlayOwners.has('pdp-addon') ||
      overlayOwners.has('cart-addon') ||
      Array.from(overlayOwners).some(function (owner) {
        return String(owner).indexOf('tingle-popup-') === 0;
      });
    if (popupOpen) {
      if (!html.classList.contains('open-popup')) {
        html.classList.add('open-popup');
        popupClassOwnedByOverlayState = true;
      }
    } else if (popupClassOwnedByOverlayState) {
      html.classList.remove('open-popup');
      popupClassOwnedByOverlayState = false;
    }
  }
  function overlayOwnerVisible(owner) {
    var name = String(owner || '');
    var html = document.documentElement;

    if (name === 'minicart') return !!document.querySelector('cart-notification.open, cart-drawer.open, .minicart.open, .minicart__wrapper.open');
    if (name === 'desktop-nav') return html.classList.contains('nav-open');
    if (name === 'mobile-drawer') return html.classList.contains('vsklo-mobile-drawer-open');
    if (name === 'collection-sidebar') {
      return html.classList.contains('open-sidebar') && !!document.querySelector('#CollectionSidebar.open');
    }
    if (name === 'search') return !!document.querySelector('#search-form.open');
    if (name === 'desktop-search') return !!document.querySelector('[data-vsklo-default-search-panel].is-open, #search-form.is-open');
    if (name === 'pdp-addon') return !!document.querySelector('[data-vsklo-addon-context="pdp"].is-active, .product-addons-popup[data-vsklo-addon-v3].is-active');
    if (name === 'cart-addon') return !!document.querySelector('[data-vsklo-cart-addon-popup].is-active');
    if (name === 'pdp-lightbox') return !!document.querySelector('[data-vsklo-lightbox].is-open, [data-vph-lightbox].is-open');
    if (name === 'before-you-leave') return html.classList.contains('open-byl') && !!document.querySelector('before-you-leave.open');
    if (name.indexOf('tingle-popup-') === 0) return !!document.querySelector('.tingle-modal--visible');
    return true;
  }

  function reconcileOverlayState() {
    Array.from(overlayOwners).forEach(function (owner) {
      if (!overlayOwnerVisible(owner)) overlayOwners.delete(owner);
    });
    syncOverlayClass();
  }

  window.VSKLOOverlayState = {
    acquire: function (owner) {
      if (owner) overlayOwners.add(String(owner));
      syncOverlayClass();
    },
    release: function (owner) {
      if (owner) overlayOwners.delete(String(owner));
      syncOverlayClass();
    },
    has: function (owner) { return overlayOwners.has(String(owner)); },
    any: function () { return overlayOwners.size > 0; },
    owners: function () { return Array.from(overlayOwners); },
    sync: syncOverlayClass,
    reconcile: reconcileOverlayState
  };

  function vskloSharedDrawerActive() {
    var html = document.documentElement;
    return (
      html.classList.contains('open-minicart') ||
      html.classList.contains('open-search') ||
      html.classList.contains('nav-open') ||
      html.classList.contains('open-sidebar') ||
      html.classList.contains('open-byl') ||
      html.classList.contains('vsklo-mobile-drawer-open')
    );
  }

  function vskloScrollbarCompensationActive() {
    return (
      vskloSharedDrawerActive() ||
      !!document.querySelector('.tingle-modal--visible') ||
      !!(document.body && document.body.classList.contains('tingle-enabled'))
    );
  }

  window.VSKLOCleanupSharedDrawerShell = function () {
    var html = document.documentElement;
    if (!vskloSharedDrawerActive()) html.classList.remove('open-drawer');
    if (!vskloScrollbarCompensationActive()) html.style.removeProperty('padding-right');
  };

  window.VSKLOSharedDrawerActive = vskloSharedDrawerActive;

  window.VSKLODispatchCartChanged = function (detail) {
    var payload = detail && typeof detail === 'object' ? detail : {};
    document.dispatchEvent(new CustomEvent('vsklo:cart:changed', { detail: payload }));
    document.dispatchEvent(new CustomEvent('vsklo:cart-updated', { detail: payload }));
  };

  function hydrateFromEvent(event) {
    schedule(event && event.detail && event.detail.scope ? event.detail.scope : (event && event.target ? event.target : document));
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { schedule(document); }, { once: true });
  } else {
    schedule(document);
  }
  document.addEventListener('shopify:section:load', hydrateFromEvent);
  document.addEventListener('vsklo:content-updated', hydrateFromEvent);
  document.addEventListener('vsklo:cart:changed', hydrateFromEvent);
  function cleanupRestoredTransientState() {
    var html = document.documentElement;

    if (html.classList.contains('open-minicart') &&
        !document.querySelector('cart-notification.open, cart-drawer.open, .minicart.open, .minicart__wrapper.open')) {
      html.classList.remove('open-minicart');
      overlayOwners.delete('minicart');
    }

    if (html.classList.contains('open-search') &&
        !document.querySelector('[data-vsklo-default-search-panel].is-open, #search-form.open, #search-form.is-open')) {
      html.classList.remove('open-search');
      overlayOwners.delete('search');
      overlayOwners.delete('desktop-search');
    }

    if (html.classList.contains('open-byl') &&
        !document.querySelector('before-you-leave.open')) {
      html.classList.remove('open-byl');
      overlayOwners.delete('before-you-leave');
    }

    if (html.classList.contains('vsklo-dialog-open') &&
        !document.querySelector('[data-vsklo-clear-cart-dialog]')) {
      html.classList.remove('vsklo-dialog-open');
    }

    syncOverlayClass();
    if (typeof window.VSKLOCleanupSharedDrawerShell === 'function') {
      window.VSKLOCleanupSharedDrawerShell();
    }
  }

  window.addEventListener('pageshow', function () {
    syncCartDeviceClass();
    reconcileOverlayState();
    schedule(document);
    window.requestAnimationFrame(cleanupRestoredTransientState);
  });
})();